import React from 'react';
import Moment from 'moment';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

const COUPON_STATUS = {
	INACTIVE: 0,
	ACTIVE: 1,
};

const FILTER_STATUS = {
	INACTIVE: 0,
	ACTIVE: 1,
	EXPIRED: 2,
};

const DISCOUNT_TYPE = {
	VALUE: 1,
	PERCENTAGE: 2,
};

export default class Coupons extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			coupons: [],
			loading: false,
			selectedDiscountType: "",
			selectedStatus: "",
		};


		this.handleSelectDiscountType = this.handleSelectDiscountType.bind(this);
		this.handleSelectStatus = this.handleSelectStatus.bind(this);
		this.computeCouponsList = this.computeCouponsList.bind(this);
	}

	componentDidMount() {
		this.fetchCoupons();
	}

	fetchCoupons = () => {

		this.setState({
			loading: true
		});

		this.props.fetchApi('get', '/coupons')
			.then((response) => {

				this.setState({
					coupons: response.data.coupons,
					loading: false
				})


			}).catch(() => {
				this.props.showSnackbar('Erro ao listar cupons. Tente novamente.');
				this.setState({
					loading: false
				})
			});
	}

	handleSelectDiscountType(_, __, value) {
		this.setState({ selectedDiscountType: value });
	}

	handleSelectStatus(_, __, value) {
		this.setState({ selectedStatus: value });
	}

	computeCouponsList(coupons, discountType, status) {
		let filtered = coupons;
		if (discountType !== "") {
			filtered = filtered.filter((coupon) => coupon.discountType === discountType);
		}
		if (status !== "") {
			if (status === FILTER_STATUS.INACTIVE) {
				filtered = filtered.filter((coupon) => coupon.status === COUPON_STATUS.INACTIVE);
			} else if (status === FILTER_STATUS.ACTIVE) {
				filtered = filtered.filter((coupon) => coupon.status === COUPON_STATUS.ACTIVE && !Moment(coupon.expirationDate).isBefore(Moment()));
			} else if (status === FILTER_STATUS.EXPIRED) {
				filtered = filtered.filter((coupon) => coupon.status === COUPON_STATUS.ACTIVE && Moment(coupon.expirationDate).isBefore(Moment()));
			}
		}
		
		filtered.sort((a, b) => Moment(b.expirationDate).diff(Moment(a.expirationDate)));

		return filtered;
	}


	render() {
		const { coupons, loading, selectedDiscountType, selectedStatus } = this.state;
		return (
			<div>
				<br />
				<br />
				<Card style={{ padding: '1rem' }}>
					<Typography color="textSecondary" gutterBottom>
						Lista de Cupons
					</Typography>
					<br />
					<InputLabel shrink >
						Filtrar por tipo de desconto
					</InputLabel>
					<Select
						value={selectedDiscountType}
						onChange={(event) => this.handleSelectDiscountType(event, null, event.target.value)}
					>
						<MenuItem value="">DESMARCAR</MenuItem>
						<MenuItem value={DISCOUNT_TYPE.VALUE}>VALOR</MenuItem>
						<MenuItem value={DISCOUNT_TYPE.PERCENTAGE}>PORCENTAGEM</MenuItem>
					</Select>
					<br />
					<br />
					<div style={{ display: "flex", justifyContent: "space-between" }}>
						<div>
							<InputLabel shrink >
								Filtrar por status
							</InputLabel>
							<Select
								value={selectedStatus}
								onChange={(event) => this.handleSelectStatus(event, null, event.target.value)}
							>
								<MenuItem value="">DESMARCAR</MenuItem>
								<MenuItem value={FILTER_STATUS.INACTIVE}>INATIVO</MenuItem>
								<MenuItem value={FILTER_STATUS.ACTIVE}>ATIVO</MenuItem>
								<MenuItem value={FILTER_STATUS.EXPIRED}>EXPIRADO</MenuItem>
							</Select>
						</div>
						<Button
							variant="contained"
							color="primary"
							onClick={() => this.props.navigateToCouponCreate()}
						>
							Criar cupon
						</Button>
					</div>
					<br />
					<br />

					{loading
						?
						<CircularProgress style={{ marginLeft: '1rem' }} />

						: (

							<TableContainer component={Paper}>
								<Table>
									<TableHead>
										<TableRow>
											<TableCell >Código</TableCell>
											<TableCell >Valor do desconto</TableCell>
											<TableCell>Tipo de desconto</TableCell>
											<TableCell>Quantidade usada</TableCell>
											<TableCell>Desconto total</TableCell>
											<TableCell>Status</TableCell>
											<TableCell>Data de expiração</TableCell>
											<TableCell>Data de criação</TableCell>
										</TableRow>
									</TableHead>
									<TableBody >
										{this.computeCouponsList(coupons, selectedDiscountType, selectedStatus).map((coupon) => {
											const hasValidDate = coupon.expirationDate && Moment(coupon.expirationDate).isValid();
											const isExpired = hasValidDate ? Moment(coupon.expirationDate).isBefore(Moment()) : true; // se inválido, trata como expirado por segurança
											const isInactive = coupon.status === COUPON_STATUS.INACTIVE;
											const cantEdit = isExpired || isInactive;

											return (
												<TableRow 
													key={coupon.id} 
													hover={!cantEdit}
													onClick={() => { if (!cantEdit) this.props.navigateToCupon(coupon.id); }}
													style={{ cursor: cantEdit ? 'default' : 'pointer', opacity: cantEdit ? 0.7 : 1 }}
												>
													<TableCell>
														{coupon.code}
													</TableCell>
													<TableCell title={coupon.discountValue}>
														{coupon.discountValue}
													</TableCell>
													<TableCell>
														{Number(coupon.discountType) === DISCOUNT_TYPE.VALUE ? 'VALOR' : 'PORCENTAGEM'}
													</TableCell>
													<TableCell>
														{coupon.usageCount || 0}
													</TableCell>
													<TableCell>
														{coupon.totalDiscount ? `R$ ${parseFloat(coupon.totalDiscount).toFixed(2).replace('.', ',')}` : 'R$ 0,00'}
													</TableCell>
													<TableCell>
														{isInactive ? 'INATIVO' : (isExpired ? 'EXPIRADO' : 'ATIVO')}
													</TableCell>
													<TableCell >
														{Moment(coupon.expirationDate).format('HH:mm - DD/MM/YYYY')}
													</TableCell>
													<TableCell >
														{Moment(coupon.createdAt).format('HH:mm - DD/MM/YYYY')}
													</TableCell>
												</TableRow>
											);
										})}
									</TableBody>
								</Table>
							</TableContainer>
						)
					}
				</Card>

			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Coupons.js